import * as React from "react";
import { useParameterType } from "./ParameterTypes";
const TypeSpecificParameterInput = ({
  parameter,
  onChange,
  onBlur,
  value,
  searchId,
  inputSize
}) => {
  const { component: Component } = useParameterType(parameter == null ? void 0 : parameter.type);
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      parameter,
      value,
      onChange,
      onBlur,
      inputSize,
      searchId
    }
  );
};
export default TypeSpecificParameterInput;
